import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ConfirmationModal from '../../../../components/ConfirmationModal';
import Textarea from '../../../../components/Textarea';
import Dropzone from '../../../../components/Dropzone';
import {
  BUTTON_LIGHT_MODAL_STYLE_BLOG,
  BUTTON_MODAL_STYLE_BLOG,
  COLORS,
  TITLE_MODAL_STYLE_BLOG,
} from '../../../../utils/const';

const { black } = COLORS;

const TeamCard = ({
  teammate,
  locales,
  locales: { portfolio },
  backgroundTeam,
  backgroundModal,
  textColor,
  disabled = false,
}) => {
  const { image, imageCoords, name, description, position, id } = teammate;
  const {
    portfolioTeammate: {
      updatePortfolioTeammate,
      updatePortfolioTeammateImage,
      updatePortfolioTeammateImageCoords,
      removePortfolioTeammate,
    },
  } = useDispatch();

  const { uploadingImage } = useSelector((state) => state.portfolioTeammate);

  const onChange = (e) => {
    updatePortfolioTeammate({
      id,
      name: e.target.name,
      value: e.target.value,
    });
  };

  const onDropImage = ([file], openCropperHandler) => {
    updatePortfolioTeammateImage({
      id,
      name: 'image',
      blob: file,
      success: () => {
        openCropperHandler();
      },
    });
  };

  const onImageCropperSave = (croppedAreaPixels, innerCropData, zoom) => {
    updatePortfolioTeammateImageCoords({
      id,
      croppedAreaPixels,
      innerCropData,
      zoom,
      coords: imageCoords,
    });
  };

  return (
    <div className="team-blogFriendly-card">
      {!disabled && (
        <div className="remove">
          <ConfirmationModal
            body={locales.common.deleteConfirmation}
            confirmText="Delete"
            onConfirm={() => removePortfolioTeammate({ id })}
          >
            <div className="icon-section">
              <i className="icon-Delete" />
            </div>
          </ConfirmationModal>
        </div>
      )}

      <div className="image-hover">
        <Dropzone
          className="image-upload"
          background={{ backgroundColor: backgroundTeam }}
          onDrop={onDropImage}
          onCropperSave={onImageCropperSave}
          locales={locales}
          image={image}
          coords={imageCoords}
          uploading={uploadingImage === teammate.id}
          aspectRatio={1}
          disabled={disabled}
          titleStyle={TITLE_MODAL_STYLE_BLOG}
          buttonStyle={BUTTON_MODAL_STYLE_BLOG}
          lightButtonStyle={BUTTON_LIGHT_MODAL_STYLE_BLOG}
          sliderColor={black}
          backgroundModal={backgroundModal}
          isTemplates
          cropper
        />
      </div>

      <div className="textarea-blog">
        <Textarea
          id="position"
          type="text"
          name="position"
          value={position}
          placeholder={portfolio.team.position}
          onChange={onChange}
          className="textarea-blogFriendly textarea-blogFriendly-team-card--position custom-font-body"
          style={{ color: textColor }}
          delay={700}
          disabled={disabled}
        />
        <Textarea
          id="fullName"
          value={name}
          onChange={onChange}
          placeholder={portfolio.team.fullName}
          name="name"
          type="text"
          className="textarea-blogFriendly textarea-blogFriendly-team-card--name custom-font-title"
          style={{ color: textColor }}
          delay={700}
          disabled={disabled}
        />
      </div>
      <div className="textarea-blog">
        <Textarea
          id="description"
          className="textarea-blogFriendly textarea-blogFriendly-team-card--description custom-font-body"
          name="description"
          placeholder={portfolio.page.description}
          value={description}
          onChange={onChange}
          style={{ color: textColor }}
          delay={700}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default TeamCard;
